import { render, staticRenderFns } from "./CartButtons.vue?vue&type=template&id=b2392200&scoped=true"
import script from "./CartButtons.vue?vue&type=script&lang=js"
export * from "./CartButtons.vue?vue&type=script&lang=js"
import style0 from "./CartButtons.vue?vue&type=style&index=0&id=b2392200&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2392200",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/html/untrrv2/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2392200')) {
      api.createRecord('b2392200', component.options)
    } else {
      api.reload('b2392200', component.options)
    }
    module.hot.accept("./CartButtons.vue?vue&type=template&id=b2392200&scoped=true", function () {
      api.rerender('b2392200', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/order/CartButtons.vue"
export default component.exports